export default "__VITE_ASSET__CdNdzu8z__"